









import { Component, Vue } from "vue-property-decorator";
import { familyBaseText } from "@/views/analys/analyChart/coms/pageBottomText";
import PageButtomText from "@/components/pageBottomText/index.vue";
import BaseSection from "./coms/basePlan.vue";
import BaseDetailSection from "./coms/basePlanDetail.vue";

@Component({
  name: "printBase",
  components: {
    BaseSection,
    BaseDetailSection,
    PageButtomText,
  },
})
export default class extends Vue {
  familyBaseText = familyBaseText;
}
